// extracted by mini-css-extract-plugin
export var borderRadius = "_ay-4";
export var large = "_ay-3";
export var logoContainer = "_ay-0";
export var nameLogo = "_ay-2";
export var small = "_ay-1";